export default __webpack_public_path__ + "static/media/main-logo-red.e67ac11d.svg";